import { type FC } from 'react'
import { Button } from '../../../../components/Button/Button'
import '../../../../components/FormSaveBar/FormSaveBar.scss'

interface ConfirmSaveBarProps {
  isVisible: boolean
  isConfirming: boolean
  isSubmitting: boolean
  isDirty: boolean
  message: string
  confirmMessage: string
  onDiscard: () => void
  onSave: () => void
  onBack: () => void
  onConfirm: () => void
}

const innerPillClass =
  'd-flex justify-content-between align-items-center zocks-bg-color-gray-900 zocks-border-0.5 zocks-p-1.25 shadow-lg mx-auto col-11 col-lg-10 inner-pill-style'

export const ConfirmSaveBar: FC<ConfirmSaveBarProps> = ({
  isVisible,
  isConfirming,
  isSubmitting,
  isDirty,
  message,
  confirmMessage,
  onDiscard,
  onSave,
  onBack,
  onConfirm,
}) => {
  if (!isVisible) {
    return null
  }

  if (isConfirming) {
    return (
      <div className='outer-container-style'>
        <div className={innerPillClass}>
          <div className='d-flex align-items-center zocks-gap-0.75'>
            <i className='bi bi-exclamation-square zocks-text-danger fs-5' />
            <span className='zocks-text-white fw-medium'>{confirmMessage}</span>
          </div>
          <div className='d-flex zocks-gap-0.75'>
            <Button type='button' variant='primaryGhost' className='border-0' onClick={onBack} disabled={isSubmitting}>
              Back
            </Button>
            <Button type='button' variant='danger' className='border-0' onClick={onConfirm} loading={isSubmitting}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='outer-container-style'>
      <div className={innerPillClass}>
        <div className='d-flex align-items-center'>
          <span className='zocks-text-gray-500'>{message}</span>
        </div>
        <div className='d-flex zocks-gap-0.75'>
          <Button type='button' variant='primaryGhost' className='border-0' onClick={onDiscard} disabled={isSubmitting}>
            Discard changes
          </Button>
          <Button type='button' variant='primary' className='border-0' onClick={onSave} disabled={isSubmitting || !isDirty}>
            Save changes
          </Button>
        </div>
      </div>
    </div>
  )
}
